import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { Card, CardContent } from "@/components/ui/card";
const Features = () => {
  const isMobile = useIsMobile();
  return <section id="features" className="py-20 bg-white relative">
      {/* Background decorative elements */}
      <div className="absolute top-20 left-0 w-72 h-72 bg-savyi-blue/5 rounded-full blur-3xl -z-10" />
      <div className="absolute bottom-20 right-0 w-80 h-80 bg-savyi-pink/5 rounded-full blur-3xl -z-10" />
      
      <div className="container mx-auto px-4">
        {/* Financial Bestie Section */}
        <div className="mt-16">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Your <span className="text-gradient">Financial Bff</span> in Action
            </h2>
            <p className="text-gray-600 text-lg">
              See how Savyi chat helps with your daily money decisions
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {/* Conversation 1: The Treat Yo'self Dilemma */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
              <div className="bg-[#1211ca] text-white p-4">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-bold">Ask Savyi</h3>
                    <p className="text-xs text-white/80">Your financial bestie</p>
                  </div>
                </div>
              </div>
              
              <div className="p-4 bg-[#efefef] h-[400px] overflow-y-auto">
                {/* User message */}
                <div className="flex justify-end mb-4">
                  <div className="bg-[#1211ca] text-white p-3 rounded-tl-xl rounded-bl-xl rounded-tr-xl max-w-[80%]">
                    <p className="text-sm">Hey Savyi, how much can I spend today? I really need a coffee pick-me-up ☕</p>
                  </div>
                </div>
                
                {/* AI response */}
                <div className="flex gap-2 mb-4">
                  <div className="w-8 h-8 rounded-full bg-[#1211ca] flex items-center justify-center text-white flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 8V4H8" />
                      <rect width="16" height="12" x="4" y="8" rx="2" />
                      <path d="M2 14h2" />
                      <path d="M20 14h2" />
                      <path d="M15 13v2" />
                      <path d="M9 13v2" />
                    </svg>
                  </div>
                  <div className="bg-white p-3 rounded-tr-xl rounded-br-xl rounded-bl-xl max-w-[80%] shadow-sm">
                    <p className="text-sm">Hey! You've got £23 left in your 'Fun Fund'! 🎉 But your 'Bali Fund' is glowing 🌴. Wanna treat yourself guilt-free?</p>
                    <div className="mt-3 space-y-2">
                      <button className="bg-[#1211ca]/10 text-[#1211ca] text-xs p-2 rounded-lg w-full text-left hover:bg-[#1211ca]/20 transition">
                        Yes, I need this! (£5)
                      </button>
                      <button className="bg-[#1211ca]/10 text-[#1211ca] text-xs p-2 rounded-lg w-full text-left hover:bg-[#1211ca]/20 transition flex items-center">
                        <span>Nah, save it for Bali</span>
                        <span className="ml-1">🌴</span>
                      </button>
                    </div>
                  </div>
                </div>
                
                {/* Fund progress */}
                <div className="bg-white rounded-xl p-3 shadow-sm mb-4">
                  <div className="space-y-3">
                    <div>
                      <div className="flex justify-between items-center mb-1">
                        <p className="text-xs font-medium">Fun Fund</p>
                        <p className="text-xs font-medium">£23/£50</p>
                      </div>
                      <div className="h-2 w-full bg-gray-200 rounded-full">
                        <div className="h-2 bg-[#1211ca] rounded-full" style={{
                        width: "46%"
                      }}></div>
                      </div>
                    </div>
                    <div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="flex items-center">
                          <p className="text-xs font-medium">Bali Fund</p>
                          <span className="ml-1">🌴</span>
                        </div>
                        <p className="text-xs font-medium">£345/£1,200</p>
                      </div>
                      <div className="h-2 w-full bg-gray-200 rounded-full">
                        <div className="h-2 bg-gradient-to-r from-[#1211ca] to-[#0072ff] rounded-full" style={{
                        width: "28%"
                      }}></div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="text-center">
                  <p className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full inline-block">
                    Option 1: Deducts £5 from Fun Fund. Adds 🎉 "Self-Care Champion" badge.
                  </p>
                </div>
                <div className="text-center mt-2">
                  <p className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full inline-block">
                    Option 2: Adds £5 to Bali Fund with confetti animation.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Conversation 2: Rent Week Panic */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
              <div className="bg-[#1211ca] text-white p-4">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-bold">Ask Savyi</h3>
                    <p className="text-xs text-white/80">Your financial bestie</p>
                  </div>
                </div>
              </div>
              
              <div className="p-4 bg-[#efefef] h-[400px] overflow-y-auto">
                {/* User message */}
                <div className="flex justify-end mb-4">
                  <div className="bg-[#1211ca] text-white p-3 rounded-tl-xl rounded-bl-xl rounded-tr-xl max-w-[80%]">
                    <p className="text-sm">Savyi, rent's due in 3 days. Can I afford takeout tonight? 🍜</p>
                  </div>
                </div>
                
                {/* AI response */}
                <div className="flex gap-2 mb-4">
                  <div className="w-8 h-8 rounded-full bg-[#1211ca] flex items-center justify-center text-white flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 8V4H8" />
                      <rect width="16" height="12" x="4" y="8" rx="2" />
                      <path d="M2 14h2" />
                      <path d="M20 14h2" />
                      <path d="M15 13v2" />
                      <path d="M9 13v2" />
                    </svg>
                  </div>
                  <div className="bg-white p-3 rounded-tr-xl rounded-br-xl rounded-bl-xl max-w-[80%] shadow-sm">
                    <p className="text-sm">Heads up! Your 'Rent Fund' needs £200 more by Friday. 😬 Let's activate Budget Shield?</p>
                    <div className="mt-3 space-y-2">
                      <button className="bg-[#1211ca]/10 text-[#1211ca] text-xs p-2 rounded-lg w-full text-left hover:bg-[#1211ca]/20 transition flex items-center">
                        <span>Activate Shield</span>
                        <span className="ml-1">🛡️</span>
                      </button>
                      <button className="bg-[#1211ca]/10 text-[#1211ca] text-xs p-2 rounded-lg w-full text-left hover:bg-[#1211ca]/20 transition">
                        Risk it for ramen?
                      </button>
                    </div>
                  </div>
                </div>
                
                {/* Fund alert */}
                <div className="bg-white rounded-xl p-3 shadow-sm mb-4">
                  <div className="space-y-3">
                    <div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="flex items-center">
                          <div className="w-4 h-4 rounded-full bg-red-500 flex items-center justify-center mr-1">
                            <span className="text-white text-[8px]">!</span>
                          </div>
                          <p className="text-xs font-medium">Rent Fund</p>
                        </div>
                        <p className="text-xs font-medium text-red-500">£600/£800 due in 3 days</p>
                      </div>
                      <div className="h-2 w-full bg-gray-200 rounded-full">
                        <div className="h-2 bg-red-400 rounded-full" style={{
                        width: "75%"
                      }}></div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="text-center mb-2">
                  <p className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full inline-block">
                    Option 1: Suggests pausing Spotify (£10) + skipping takeout (£25).
                  </p>
                </div>
                <div className="text-center">
                  <p className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full inline-block">
                    Option 2: Shows impact on rent goal. "We can try shuffling funds later..."
                  </p>
                </div>

                <div className="mt-4 bg-white rounded-xl p-3 shadow-sm">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-[#1211ca]/10 flex items-center justify-center text-[#1211ca]">
                      <span className="text-sm font-bold">🛡️</span>
                    </div>
                    <div>
                      <p className="text-xs font-medium">Budget Shield Suggestion</p>
                      <p className="text-xs text-gray-500">Pause Spotify (£10) + Skip takeout (£25) = £35 closer to rent</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Conversation 3: Big Purchase Temptation */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
              <div className="bg-[#1211ca] text-white p-4">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-bold">Ask Savyi</h3>
                    <p className="text-xs text-white/80">Your financial bestie</p>
                  </div>
                </div>
              </div>
              
              <div className="p-4 bg-[#efefef] h-[400px] overflow-y-auto">
                {/* User message */}
                <div className="flex justify-end mb-4">
                  <div className="bg-[#1211ca] text-white p-3 rounded-tl-xl rounded-bl-xl rounded-tr-xl max-w-[80%]">
                    <p className="text-sm">Can I buy that £600 laptop? My old one's dying 💻</p>
                  </div>
                </div>
                
                {/* AI response */}
                <div className="flex gap-2 mb-4">
                  <div className="w-8 h-8 rounded-full bg-[#1211ca] flex items-center justify-center text-white flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 8V4H8" />
                      <rect width="16" height="12" x="4" y="8" rx="2" />
                      <path d="M2 14h2" />
                      <path d="M20 14h2" />
                      <path d="M15 13v2" />
                      <path d="M9 13v2" />
                    </svg>
                  </div>
                  <div className="bg-white p-3 rounded-tr-xl rounded-br-xl rounded-bl-xl max-w-[80%] shadow-sm">
                    <p className="text-sm">Your 'Tech Upgrade' fund has £300. So close! Let's make a plan:</p>
                    <div className="mt-3 space-y-2">
                      <button className="bg-[#1211ca]/10 text-[#1211ca] text-xs p-2 rounded-lg w-full text-left hover:bg-[#1211ca]/20 transition">
                        Start #GrindMode Quest
                      </button>
                      <button className="bg-[#1211ca]/10 text-[#1211ca] text-xs p-2 rounded-lg w-full text-left hover:bg-[#1211ca]/20 transition">
                        Explore Fund Shuffle?
                      </button>
                    </div>
                  </div>
                </div>
                
                {/* Laptop progress visualization */}
                <div className="bg-white rounded-xl p-3 shadow-sm mb-4">
                  <div className="space-y-3">
                    <div>
                      <div className="flex justify-between items-center mb-1">
                        <div className="flex items-center">
                          <p className="text-xs font-medium">Tech Upgrade Fund</p>
                          <span className="ml-1">💻</span>
                        </div>
                        <p className="text-xs font-medium">£300/£600</p>
                      </div>
                      <div className="h-8 w-full bg-gray-200 rounded-lg overflow-hidden relative">
                        <div className="h-full bg-[#1211ca] rounded-l-lg" style={{
                        width: "50%"
                      }}>
                          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                            <span className="text-xs font-bold text-white">£300 saved</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="flex bg-white p-3 rounded-lg mb-4 shadow-sm">
                  <div className="flex-1">
                    <h4 className="text-sm font-medium">#GrindMode Quest</h4>
                    <p className="text-xs text-gray-500">Save £50/week → Laptop unlocked in 6 weeks!</p>
                  </div>
                  <div className="w-8 h-8 rounded-full bg-[#1211ca]/10 flex items-center justify-center text-[#1211ca]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                    </svg>
                  </div>
                </div>
                
                <div className="text-center mb-2">
                  <p className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full inline-block">
                    Option 1: Sets up savings quest with weekly rewards.
                  </p>
                </div>
                <div className="text-center">
                  <p className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full inline-block">
                    Option 2: Explores raiding 'Takeout Fund' (£150) + boosting side hustle.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center max-w-3xl mx-auto mb-16 mt-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Your <span className="text-gradient">Financial Sixth Sense</span>
          </h2>
          <p className="text-gray-600 text-lg">
            We see the whole picture: bank feeds, crumpled receipts, angry creditor letters, and your midnight "I need a win" moments.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <FeatureCard icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
              </svg>} title="AI That Reads Between the Lines" color="savyi-purple" description="Scans anything: receipts, contracts, sticky notes, even that passive-aggressive 'PAY NOW' letter. Extracts urgency and auto-sorts chaos." />
          
          <FeatureCard icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>} title="Real Talk AI (No Toxic Positivity)" color="savyi-pink" description="Ask 'Can I splurge today?' → Savyi shows consequences but compromises. Learns your stress triggers and helps you find balance." />
          
          <FeatureCard icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
              </svg>} title="Gamification with Grown-Up Priorities" color="savyi-yellow" description="Battle 'Debt Demons' with urgency-based power-ups. Grow a 'Dream Fund Garden' that wilts if you ignore bills but blooms with progress." />
          
          <FeatureCard icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
                <circle cx="12" cy="13" r="3" />
              </svg>} title="Scan & Slay" color="savyi-blue" description="Snap a pic → AI redacts sensitive info, logs deadlines, and updates your plan. 'Scanned a parking ticket? We'll nudge you to pay before it doubles.'" />
          
          <FeatureCard icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>} title="Privacy, But Make It Glow" color="savyi-teal" description="Bank-grade security + auto-redaction on scans. Your ex's Venmo requests stay vaulted. We keep your data private and secure." />
          
          <FeatureCard icon={<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2v8" />
                <path d="m4.93 10.93 1.41 1.41" />
                <path d="M2 18h2" />
                <path d="M20 18h2" />
                <path d="m19.07 10.93-1.41 1.41" />
                <path d="M22 22H2" />
                <path d="m8 22 4-10 4 10" />
              </svg>} title="Empathy-Driven Design" color="savyi-orange" description="Balances discipline + mental health. 'Need a cheat day? We'll recalibrate.' No judgment, just realistic solutions for real-life finances." />
        </div>
      </div>
    </section>;
};
interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  color: string;
}
const FeatureCard = ({
  icon,
  title,
  description,
  color
}: FeatureCardProps) => {
  return <Card className="feature-card h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <div className={`w-12 h-12 mb-5 rounded-lg flex items-center justify-center bg-${color}/10 text-${color}`}>
          {icon}
        </div>
        <h3 className="text-xl font-bold mb-3">{title}</h3>
        <p className="text-gray-600 flex-1">{description}</p>
        <div className="shimmer"></div>
      </CardContent>
    </Card>;
};
export default Features;